import Swal from 'sweetalert2'

// toast config
const Toast = Swal.mixin({
    toast: true,
    position: "bottom",
    timer: 1000,
    timerProgressBar: true,
    showConfirmButton: false
  });
  window.Toast = Toast